import { create } from 'zustand';
import { 
  get_users, 
  post_user, 
  update_user, 
  delete_user 
} from '../utils/apis/users';

export const useUserStore = create((set, get) => ({
  users: [],
  loading: false,
  error: null,

  getUserList: async () => {
    set({ loading: true });
    try {
      const result = await get_users();
      set({ users: result || [], loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  postNewUser: async (data) => {
    set({ loading: true });
    try {
      const res = await post_user(data);
      if (res && res.inserted_id) {
        await get().getUserList();
      }
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  updateUser: async (data) => {
    set({ loading: true });
    try {
      const res = await update_user(data);
      await get().getUserList();
      set({ loading: false });
      return res;
    } catch (error) {
      set({ error: error.message, loading: false });
      return null;
    }
  },

  deleteUser: async (data) => {
    set({ loading: true });
    try {
      await delete_user(data);
      await get().getUserList();
      set({ loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },
}));
